import React from "react";
import { useI18n } from "@/context/LangContext";
import { LANGS } from "@/lib/i18n";

export default function LangSwitcher({ compact = false }) {
  const { lang, setLang } = useI18n();
  return (
    <div
      data-testid="lang-switcher"
      role="group"
      aria-label="Language"
      className={`inline-flex border border-[color:var(--line)] bg-white ${compact ? "text-[10px]" : "text-xs"}`}
    >
      {Object.entries(LANGS).map(([code, info]) => (
        <button
          key={code}
          type="button"
          data-testid={`lang-${code}`}
          onClick={() => setLang(code)}
          aria-pressed={lang === code}
          className={`px-2 py-1 font-mono uppercase tracking-widest transition-colors ${
            lang === code
              ? "bg-[color:var(--brand)] text-white"
              : "text-neutral-600 hover:bg-neutral-100"
          }`}
        >
          {info.short}
        </button>
      ))}
    </div>
  );
}
